export default __webpack_public_path__ + "static/media/img3.845a9d5b.png";